<svelte:options
  customElement={{
    tag: "oc-chat-bubble-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      variant: { type: "String" },
      sender: { type: "String" },
      timestamp: { type: "String" },
      hideDate: { type: "Boolean", attribute: "hide-date" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./ChatBubbleV1.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";
  import { getFormattedDatetimeString } from "../../../common/utils/datetimeFormatter";

  let { variant = "sent", sender = "", timestamp = "", hideDate = false }: Props = $props();
</script>

<div class={`chat-bubble chat-bubble--${variant}`}>
  {#if sender !== "" || timestamp !== ""}
    <div class="chat-bubble__overline">
      {#if sender !== ""}
        <p class="chat-bubble__sender">{sender}</p>
      {/if}
      {#if timestamp !== ""}
        <p class="chat-bubble__timestamp">{getFormattedDatetimeString(timestamp, hideDate)}</p>
      {/if}
    </div>
  {/if}
  <slot />
</div>

<DefaultStyles />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :global {
    :host {
      display: block;
      --background-color: initial;
      --text-color: initial;
    }

    .chat-bubble {
      padding: tokens.$oc-component-chat-bubble-spacing-y tokens.$oc-component-chat-bubble-spacing-x;
      border-radius: tokens.$oc-component-chat-bubble-border-radius;
      background-color: var(
        --background-color,
        #{tokens.$oc-component-chat-bubble-background-color}
      );
      color: var(--text-color, #{tokens.$oc-component-chat-bubble-text-color});
      font: tokens.$oc-component-chat-bubble-text-font;
      display: flex;
      flex-direction: column;
      gap: tokens.$oc-component-chat-bubble-gap-y;
      max-width: 80%;
      width: fit-content;

      &--sent {
        border-bottom-right-radius: 0;
        margin-left: auto;
      }

      &--received {
        border-bottom-left-radius: 0;
        margin-right: auto;
      }

      &__overline {
        display: flex;
        flex-wrap: wrap;
        gap: tokens.$oc-semantic-spacing-25;

        > p {
          margin: 0;
        }
      }

      &__sender {
        color: var(--text-color, #{tokens.$oc-component-chat-bubble-sender-color});
        font: tokens.$oc-component-chat-bubble-sender-font;
        font-weight: tokens.$oc-component-chat-bubble-sender-font-weight;
      }

      &__timestamp {
        color: var(--text-color, #{tokens.$oc-component-chat-bubble-datetime-color});
        font: tokens.$oc-component-chat-bubble-datetime-font;
      }
    }
  }
</style>
